export default {
      id: "right-arrow-usage",
      viewBox: "0 0 23.943 41.465",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#right-arrow",
      toString: function () {
        return this.url;
      }
    }